<template>
  <slotted-dialog :title="$t('servicesystem.common_objects.map.settings')" :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">

    <template v-slot:content>
      <v-container>
        <v-row>
          <v-col>
             {{ $t("servicesystem.common_objects.map.options") }}
            <v-select v-model="mapOptions.mapTypeId" :label="$t('servicesystem.common_objects.map.type')" class="mt-5"
              :items="[{ text: $t('servicesystem.common_objects.map.type_roadmap'), value: 'roadmap' }, { text: $t('servicesystem.common_objects.map.type_satellite'), value: 'hybrid' }]" :item-text="'text'"
              :item-value="'value'" dense hide-details>
            </v-select>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col>
            {{ $t("servicesystem.common_objects.map.controls_hint") }}
            <v-checkbox v-model="mapOptions.disableDefaultUI" :label="$t('servicesystem.common_objects.map.controls_navigator')" dense hide-details :true-value="false"
              :false-value="true">
            </v-checkbox>
            <v-checkbox v-model="mapOptions.zoomControl" :label="$t('servicesystem.common_objects.map.controls_zoom')" dense hide-details>
            </v-checkbox>
            <v-checkbox v-model="mapOptions.mapTypeControl" :label="$t('servicesystem.common_objects.map.controls_map_type')" dense hide-details>
            </v-checkbox>
            <v-checkbox v-model="mapOptions.scaleControl" :label="$t('servicesystem.common_objects.map.controls_scale')" dense hide-details>
            </v-checkbox>
            <!-- commented out due to issues whith streetview
            <v-checkbox v-model="mapOptions.streetViewControl" :label="$t('servicesystem.common_objects.map.controls_street_view')" dense hide-details>
            </v-checkbox>
            -->
            <v-checkbox v-model="mapOptions.rotateControl" :label="$t('servicesystem.common_objects.map.controls_rotate')" dense hide-details>
            </v-checkbox>
            <v-checkbox v-model="mapOptions.fullscreenControl" :label="$t('servicesystem.common_objects.map.controls_fullscreen')" dense hide-details>
            </v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </template>

  </slotted-dialog>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "MapOptionsDialog",
  props: {
    trigger: Number,
    mapOptions: Object,
  },
  components: {
    SlottedDialog,

  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      loading: false,
    };
  },

  methods: {},

  computed: {},

  watch: {
    trigger: function () {
      this.dialogtrigger++;
    },
  },
};
</script>